<template>
    <b-modal size="lg" id="defaultModal" hide-footer centered> <Zoomer v-if="action.action === 'zoomer'" :action="action"> </Zoomer> </b-modal>
</template>

<script>
import Zoomer from "../actions/Zoomer";

export default {
    props: ["action"],
    data() {
        return {};
    },
    components: {
        Zoomer
    },
    watch: {},
    mounted() {},
    methods: {},
    computed: {},
    created() {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// Modal.vue?7a3e3770